module.exports = __webpack_public_path__ + "static/media/cls.e6992a3a.png";